var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55355 7.64645L4.70711 4.8L4.8 4.70711L7.64645 7.55355L8 7.90711L8.35355 7.55355L11.2 4.70711L11.2929 4.8L8.44645 7.64645L8.09289 8L8.44645 8.35355L11.2929 11.2L11.2 11.2929L8.35355 8.44645L8 8.09289L7.64645 8.44645L4.8 11.2929L4.70711 11.2L7.55355 8.35355L7.90711 8L7.55355 7.64645Z",
    fill: "#989898",
    stroke: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDelete);
export default __webpack_public_path__ + "static/media/search_delete.687855865c6bedda6dee5d1a8b4b1f08.svg";
export { ForwardRef as ReactComponent };